import React from 'react';

import { SvgIconProps } from '@mui/material/SvgIcon';

import { ReactComponent as Close } from '../../../../assets/icons/small/close.svg';
import { ReactComponent as Pencil } from '../../../../assets/icons/small/pencil.svg';
import { useTheme } from '@mui/material';


export type CustomIconProps = {
  icon: IconTypes;
};

export type IconTypes =
  'CLOSE' |
  'PENCIL';



export const __icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  CLOSE: <Close />,
  PENCIL: <Pencil />
};

export const FC = (props: CustomIconProps & SvgIconProps) => {
  const theme = useTheme();
  const Res = __icon2iconUrl[props.icon];
  const stroke = props.stroke
    ? props.stroke
    : theme.palette.customGray.dark;

  return (

    <Res.type
      {...props}
      stroke={stroke}
    />

  );
};
